import React from "react";

/**
 * Highlights all matching substrings within a given text based on the highlight query.
 *
 * @param text - The full string to search within.
 * @param highlight - The substring to highlight in the text.
 * @returns JSX.Element[] | string - Returns the text with matching parts wrapped in a styled <span>.
 */
export const highlightText = (text: string | null | undefined, highlight: string): React.ReactNode => {
  // Return empty string if text is null or undefined
  if (!text) return "";

  // Return original text if no highlight is provided
  if (!highlight) return text;

  // Case-insensitive match for the highlight term
  const regex = new RegExp(`(${highlight})`, 'gi');

  // Split text into parts using the regex
  const parts = text.split(regex);

  // Highlight matched parts
  return parts.map((part, index) =>
    regex.test(part) ? (
      <span key={index} style={{ backgroundColor: '#c0f2ee' }}>{part}</span>
    ) : (
      part
    )
  );
};
